import React from "react";
import { connect } from "react-redux";
import { Alert, Button, Card, CardBody, Col, DropdownItem, Row } from "reactstrap";
import {
  ActionsRow,
  FixedDropDownButton,
  HorizontalLoader,
  Icon,
  InfiniteScroll,
  Loader,
  modal,
  utils,
} from "@mc/mc-legacy";
import * as findSignConnectorsActions from "../../../actions/findSignConnectorsActions";
import { DetailValue } from "@mc/mc-legacy";
import "./SignConfigurationsList.scss";
import QSignAdminApi from "../../../api/gen/qsign/QSignAdminApi";
import * as appUtils from "../../../utils/appUtils";
import PodepisovaniForm from "../../forms/PodepisovaniForm";
import * as LevelInfo from "../../../api/SignLevelInfo";
import * as SignSourceInfo from "../../../api/SignSourceInfo";
/**
 */

class PodepisovaniList extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.fetchData(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps);
  }

  fetchData = (props) => {
    props.dispatch(findSignConnectorsActions.fetchSignConnectorsIfNeeded());
  };

  upravData(data) {
    const {
      tsConnectorId,
      razitko,
      levelRazitko,
      sourceRazitko,
      tsUrl,
      tsLogin,
      tsPassword,
      tsCertPath,
      tsCertPassword,
      tsTimeout,
      razitkoConnectorName,
      ...other
    } = data;
    const signConnector = {
      ...other,
      timestampConnector: razitkoConnectorName
        ? {
            connectorId: tsConnectorId,
            connectorName: razitkoConnectorName,
            level: levelRazitko,
            source: sourceRazitko,
            tsCertPath,
            tsCertPassword,
            tsUrl,
            tsLogin,
            tsPassword,
            tsTimeout,
          }
        : null,
    };
    return signConnector;
  }
  handleEditConfig = (item) => {
    const { dispatch } = this.props;
    const { timestampConnector, connectorId, ...other } = item;
    let stampData;
    if (timestampConnector) {
      const {
        connectorId,
        tsUrl,
        tsLogin,
        tsPassword,
        tsCertPath,
        tsCertPassword,
        tsTimeout,
        connectorName,
        level,
        source,
      } = timestampConnector;
      stampData = {
        tsConnectorId: connectorId,
        tsUrl,
        tsLogin,
        tsPassword,
        tsCertPath,
        tsCertPassword,
        tsTimeout,
        levelRazitko: level,
        sourceRazitko: source,
        razitkoConnectorName: connectorName,
      };
    } else {
      stampData = {};
    }
    dispatch(
      modal.ModalActions.show(
        PodepisovaniForm,
        {
          onSubmit: (data) => {
            const tempConnector = this.upravData(data);
            const signConnector = { connectorId, ...tempConnector };
            return QSignAdminApi.updateSignConnector(signConnector);
          },
          onSubmitSuccess: (result, dispatch) => {
            dispatch(modal.ModalActions.hide());
            dispatch(findSignConnectorsActions.invalidate());
          },
          initialValues: {
            ...other,
            razitko: timestampConnector ? true : null,
            ...stampData,
          },
        },
        "Úprava konfigurace",
        {}
      )
    );
  };

  handleDeleteConfig = (item) => {
    const { dispatch } = this.props;
    dispatch(
      modal.ModalActions.showConfirm(
        "Potvrzení smazání",
        "Opravdu chcete smazat konfiguraci " + item.connectorName + "?",
        () =>
          QSignAdminApi.deleteSignConnector(item.connectorId).then(() => {
            dispatch(findSignConnectorsActions.invalidate());
          }),
        null,
        "Potvrdit"
      )
    );
  };
  handleNovy = () => {
    const { dispatch } = this.props;
    dispatch(
      modal.ModalActions.show(
        PodepisovaniForm,
        {
          onSubmit: (data) => {
            const signConnector = this.upravData(data);
            return QSignAdminApi.addSignConnector(signConnector);
          },
          onSubmitSuccess: (result, dispatch) => {
            dispatch(modal.ModalActions.hide());
            dispatch(findSignConnectorsActions.invalidate());
          },
        },
        "Konfigurace podepisování"
      )
    );
  };
  renderItem = (item, key) => {
    return (
      <Card key={key}>
        <CardBody>
          <ActionsRow actions={this.renderActions(item)}>
            <Row>
              <Col xs={12} md={4}>
                <DetailValue textOverflow label="název">
                  {item.connectorName}
                </DetailValue>
              </Col>
              <Col xs={6} md={3}>
                <DetailValue textOverflow label="Typ">
                  {SignSourceInfo.getCaption(item.source)}
                </DetailValue>
              </Col>
              <Col xs={6} md={3}>
                <DetailValue textOverflow label="Úroveň">
                  {LevelInfo.getCaption(item.level)}
                </DetailValue>
              </Col>
              <Col xs={6} md={2}>
                <DetailValue textOverflow label="Časové razítko ">
                  {item.timestampConnector ? "Ano" : "Ne"}
                </DetailValue>
              </Col>
            </Row>
          </ActionsRow>
        </CardBody>
      </Card>
    );
  };
  renderActions = (item) => {
    return (
      <Col className="item-actions">
        <FixedDropDownButton color="action" noCaret title={<Icon icon="ellipsis-v" className="item-actions-icon" />}>
          <DropdownItem key="1" onClick={() => this.handleEditConfig(item)}>
            Upravit
          </DropdownItem>
          <DropdownItem key="2" onClick={() => this.handleDeleteConfig(item)}>
            Smazat
          </DropdownItem>
        </FixedDropDownButton>
      </Col>
    );
  };

  render() {
    const { PodepisovaniList } = this.props;

    /*  if (!signConfigurationList) {
        return <Loader/>;
    } */
    if (!PodepisovaniList) {
      return <Loader />;
    }

    return (
      <div className="mb-5">
        <Row className="d-flex">
          <Col className="ml-1">
            <h2>{"Seznam podpisů"}</h2>
          </Col>
          <Col className="d-flex">
            <Button
              color="primary"
              className="mr-3"
              style={{
                marginLeft: "auto",
              }}
              onClick={this.handleNovy}
            >
              Přidat
            </Button>
          </Col>
        </Row>
        <InfiniteScroll className="config-list" bordered>
          {PodepisovaniList.isFetching && <HorizontalLoader key={'loader'} hover />}
          {PodepisovaniList.rows.length > 0
            ? PodepisovaniList.rows.map((item, key) => {
                return this.renderItem(item, key);
              })
            : !PodepisovaniList.isFetching && (
                <Row className="justify-content-center">
                  <h4>Není definován žádný podpis</h4>
                </Row>
              )}
        </InfiniteScroll>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    PodepisovaniList: utils.storeFromArea(state, findSignConnectorsActions.SIGN_CONNECTOR_LIST),
  };
}

export default connect(mapStateToProps)(PodepisovaniList);
